import * as React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { createStructuredSelector } from 'reselect';
import { CommandBar, ICommandBarItemProps } from '@fluentui/react/lib/CommandBar';
import { getClassNames } from './index.classNames';
import { DocumentActions as UiDocumentActions} from '../../../redux/actions/ui';
import { CommandActions as DocumentCommandActions} from '../../../redux/actions/document';
import { CommandActions as DocumentsCommandActions} from '../../../redux/actions/documents';
import { CommandActions as ModalCommandActions} from '../../../redux/actions/modal';
import _ from 'lodash'
import { getFilterPanelOpened } from '../../../redux/reducers/ui';
import { getTotal } from '../../../redux/reducers/documents';
import { getStatusValues } from '../../../redux/reducers/sharedData';
import { Status } from '../../../models/status';
import { InternalRoleActionsType, ExternalRoleActionsType, isExternalApp } from '../../../utils/costants';
import { getSelectedProject, getSelectedProjectCodeword } from '../../../redux/selectors/project';
import { Project } from '../../../models/project';
import { getContextualDocuments, getSelectedDocument, getSelectedDocuments } from '../../../redux/selectors/documents';
import { Document, getChangeStatusEmptyFileForm, getEmptyFileForm } from '../../../models/document';
import { getSelectedProjectCustomerStakeholders } from '../../../redux/selectors/administration';
import { StakeHolder } from '../../../models/stakeHolder';
import { withTranslation, WithTranslation  } from 'react-i18next';
import { formatDateFile } from '../../../utils/functions';

export interface ContactsProps extends WithTranslation  {
    filterPanelOpened: boolean, 
    documents: Document[],
    selectedDocument?: Document,
    total: number,
    loading: boolean,
    loadingContent: boolean,
    loadingScroll: boolean,
    statusValues: Status[],
    userProjectActions: InternalRoleActionsType[] | ExternalRoleActionsType[],
    selectedProject?: Project,
    customerStakeholders: StakeHolder[],
    codeWord?: string,
    setFilterPanelOpened: typeof UiDocumentActions.setFilterPanelOpened,
    setOpenModal: typeof DocumentCommandActions.setOpenModal,
    openGenericModal: typeof ModalCommandActions.openModal,
    fetchDocuments: typeof DocumentsCommandActions.fetchDocuments,
    openEditModal: typeof DocumentsCommandActions.openEditModal,
}

class DocumentsCommandBar extends React.Component<ContactsProps> {
    constructor(props: ContactsProps) {
        super(props);
    }   


    getButtons = () => {
        const { documents, total, selectedDocument, openGenericModal, loadingContent, loading, loadingScroll, statusValues, userProjectActions, customerStakeholders, codeWord, t, fetchDocuments, openEditModal } = this.props;
        let buttons: ICommandBarItemProps[] = [];
        let publishedStatus = _.find(statusValues, a => a.name === 'published') as Status;
        //let parterReservedStatus = _.find(statusValues, a => a.name === 'partner-reserved') as Status;
        let selectedDocumentIds = _.map(documents, d => d.id as number);
        const commentsExist = (documents && documents.length > 0) ? _.some(documents, d => d.comments && d.comments.length > 0) : true;
        const singleCustomer = (customerStakeholders.length === 1) ? customerStakeholders[0] : undefined;
        let rejectedStatus = _.find(statusValues, a => a.name === 'rejected') as Status;
        buttons = [        
            ...((_.find(userProjectActions, a => a === 'PublishPublish')) ? [{
                key: 'publish',
                name: t('Publish'),
                disabled: (selectedDocumentIds.length === 0 || _.some(documents, d => !d.isCurrent) || loadingContent || loading || loadingScroll),
                onClick: () => {openGenericModal({id: 'changeStatus', contextItem: {newStatus: {...publishedStatus}, fileForm: getChangeStatusEmptyFileForm(singleCustomer)}})},
                iconProps: {
                    iconName: (publishedStatus) ? publishedStatus.icon : undefined,
                    style: {color: (publishedStatus) ? publishedStatus.color : undefined} 
                }
            }] : []),  
            ...((_.find(userProjectActions, a => a === 'DeclinePublish')) ? [{
                key: 'decline',
                name: t('Reject'),
                disabled: (selectedDocumentIds.length === 0 || _.some(documents, d => !d.isCurrent) || loadingContent || loading || loadingScroll),
                onClick: () => {openGenericModal({id: 'changeStatus', contextItem: {newStatus: {...rejectedStatus}, fileForm: getChangeStatusEmptyFileForm()}})},
                iconProps: {
                    iconName: (rejectedStatus) ? rejectedStatus.icon : undefined,
                    style: {color: (rejectedStatus) ? rejectedStatus.color : undefined} 
                }
            }] : []),    
            ...(_.find(userProjectActions, a => a === 'EditPublish') ? [{
                key: 'editDocument',
                name: t('Edit'),
                disabled: (selectedDocumentIds.length === 0 || _.some(documents, d => !d.isCurrent || (d.status && d.status.name === 'canceled')) || loadingContent || loading || loadingScroll),
                onClick: () => {openEditModal()},
                iconProps: {
                    iconName: 'Edit'
                },
            }] : []), 
            ...(_.find(userProjectActions, a => a === 'UploadAttachmentPublish' || a === 'UploadCommentFilePublish') ? [{
                key: 'upload',
                name: t('Upload'),
                disabled: (selectedDocumentIds.length !== 1 || (selectedDocument && !selectedDocument.isCurrent) || (selectedDocument && selectedDocument.status && selectedDocument.status.name === 'canceled') || loadingContent || loading || loadingScroll),
                onClick: () => {openGenericModal({id: 'uploadDocuments', contextItem: {files: [], fileForm: getEmptyFileForm((_.find(userProjectActions, a => a === 'UploadAttachmentPublish')) ? true : false, (_.find(userProjectActions, a => a === 'UploadCommentFilePublish')) ? true : false)}})},
                iconProps: {
                    iconName: 'BulkUpload'
                },
            }] : []),   
            // ...(_.find(userProjectActions, a => a === 'DeletePublish') ? [{
            //     key: 'delete',
            //     name: t('Delete'),
            //     disabled: (selectedDocumentIds.length === 0 || !(_.every(documents, d => d.isCurrent && d.status && (d.status.name === 'uploaded'))) || loadingContent || loading || loadingScroll),
            //     onClick: () => {openGenericModal({id: 'deleteDocument'})},
            //     iconProps: {
            //         iconName: 'Cancel',
            //         style: {color: "red"}
            //     },
            // }] : []),
            ...(_.find(userProjectActions, a => a === 'ReadPublish') ? [{
                key: 'downlaod',
                name: t('Download'),
                disabled: (loadingContent || loading || loadingScroll),
                iconProps: {
                    iconName: t('Download'),
                },
                subMenuProps: {
                    items: [
                        {
                            key: 'downlaodFiles',
                            name: t('Files'),
                            disabled: (total === 0 || !_.some(documents, d => d.files.length > 0) || loadingContent || loading || loadingScroll),
                            onClick: () => { openGenericModal({id: 'fileName', contextItem: {fileName: codeWord + '_Documents_' + formatDateFile(new Date()), isParent: false}}) },
                            iconProps:  {
                                iconName: 'DownloadDocument'
                            } 
                        },
                        {
                            key: 'downloadComments',
                            name: t('Comments'),
                            disabled: (total === 0 || !commentsExist || loadingContent || loading || loadingScroll),
                            onClick: () => { openGenericModal({id: 'comments', optional: codeWord + '_Comments_' + formatDateFile(new Date())}) },
                            iconProps: {
                                iconName: 'Comment',
                            },
                        }
                    ]
                }          
            }] : []),         
            ...(!isExternalApp || _.find(userProjectActions, a => a === 'ReserveNumbersDashboard') ? [{
                key: 'excelReport',
                name: t('Report'),
                disabled: (total === 0 || loadingContent || loading || loadingScroll),
                onClick: () => { openGenericModal({id: 'excelReport', optional: codeWord + '_Document report_' + formatDateFile(new Date())}) },
                iconProps: {
                    iconName: 'ExcelDocument',
                    style: {color: "#008000"}
                  },
            }] : []), 
            {
                key: 'refresh',
                name: t('Refresh'),
                disabled: (loadingContent || loading || loadingScroll),
                onClick: () => { fetchDocuments({}) },
                iconProps: {
                    iconName: 'Refresh',
                },
            }                           
        ]
        return buttons;
    };

    getFarButtons = () => {
      const {setFilterPanelOpened, filterPanelOpened, t} = this.props;
      return [
     
        {
          key: 'openPanel',
          name: t('Filters'),
          iconProps: {
            iconName: 'Filter'
          },
          ariaLabel: 'Filters',    
          onClick: () => {setFilterPanelOpened({open: !filterPanelOpened})}      
        },          
      ]; 
  };

    render() {
        const styles = getClassNames();
        return (
            <>
                <CommandBar
                    styles={{root: styles.root, secondarySet: {borderTop: 1}}}
                    items={this.getButtons()}
                    farItems={this.getFarButtons()}
                />
            </>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    filterPanelOpened: getFilterPanelOpened,
    documents: getContextualDocuments,
    total: getTotal,
    statusValues: getStatusValues,
    selectedProject: getSelectedProject,
    selectedDocument: getSelectedDocument,
    customerStakeholders: getSelectedProjectCustomerStakeholders,
    codeWord: getSelectedProjectCodeword
});

function matchDispatchToProps(dispatch: any){
    return bindActionCreators({
        setFilterPanelOpened: UiDocumentActions.setFilterPanelOpened,
        setOpenModal: DocumentCommandActions.setOpenModal,
        openGenericModal: ModalCommandActions.openModal,
        fetchDocuments: DocumentsCommandActions.fetchDocuments,
        openEditModal: DocumentsCommandActions.openEditModal,
    }, dispatch);
}


export default connect(mapStateToProps, matchDispatchToProps)(withTranslation()((DocumentsCommandBar)));
